import { apiGet } from "@/shared/api";
import type { UnreadSnapshot } from "./notification";

export async function fetchUnreadCount(): Promise<UnreadSnapshot> {
  return apiGet<UnreadSnapshot>("/api/mail/unread-count");
}
